import Vue from 'vue'
import Router from 'vue-router'
// import Home from '../view/home/home'
// import Play from '@/view/play/play'
// import PlayTeleplay from '@/view/play/play-teleplay'
// import PlayHls from '@/view/play/play-hls'
// import PlayMovie from '@/view/play/Play-movie'
// import PlayKaoyan from '@/view/play/Play-kaoyan'
// import Upload from '@/view/upload/upload'
// import UploadMovie from '@/view/upload/upload-movie'
// import UploadTv from '@/view/upload/upload-tv'
// import UploadAnime from '@/view/upload/upload-anime'
// import Uploadpostgradute from '@/view/upload/upload-postgraduate'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      // component: Home
      component: resolve => require(['@/view/home/home'], resolve)
    },
    {
      path: '/music',
      name: 'music',
      // component: Home
      component: resolve => require(['@/view/music/music'], resolve)
    },
    {
      path: '/play',
      name: 'play',
      // component: Play
      component: resolve => require(['@/view/play/play'], resolve)

    },
    {
      path: '/playteleplay',
      name: 'playteleplay',
      // component: PlayTeleplay
      component: resolve => require(['@/view/play/play-teleplay'], resolve)

    },
    {
      path: '/playmovie',
      name: 'playmovie',
      // component: PlayMovie
      component: resolve => require(['@/view/play/Play-movie'], resolve)
    },
    {
      path: '/playmkaoyan',
      name: 'playkaoyan',
      // component: PlayKaoyan
      component: resolve => require(['@/view/play/Play-kaoyan'], resolve)

    },
    {
      path: '/playhls',
      name: 'playhls',
      // component: PlayHls
      component: resolve => require(['@/view/play/play-hls'], resolve)

    },
    {
      path: '/upload',
      name: 'upload',
      // component: Upload,
      component: resolve => require(['@/view/upload/upload'], resolve),
      children: [
        {
          path: '/uploadmovie',
          // component: UploadMovie
          component: resolve => require(['@/view/upload/upload-movie'], resolve)

        },
        {
          path: '/uploadtv',
          // component: UploadTv
          component: resolve => require(['@/view/upload/upload-tv'], resolve)

        },
        {
          path: '/uploadanime',
          // component: UploadAnime
          component: resolve => require(['@/view/upload/upload-anime'], resolve)

        },
        {
          path: '/uploadpostgradute',
          // component: Uploadpostgradute
          component: resolve => require(['@/view/upload/upload-postgraduate'], resolve)

        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js